import { ProgressItem } from '../../../../../../global/components/navigation/generic-stepper';
import { AccountInfoRoutes } from '../../../../../account-info/constants/routes';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { BenefitEnrollmentStep } from '../../models/pension-enrollment-models';

export function getEmployeeRecordSteps(isNep: boolean) {
	if (isNep) return [BenefitEnrollmentStep.PERSONAL_INFORMATION, BenefitEnrollmentStep.RELATIONSHIP];
	return [BenefitEnrollmentStep.PERSONAL_INFORMATION, BenefitEnrollmentStep.RELATIONSHIP, BenefitEnrollmentStep.EMPLOYMENT];
}

export function getEmployeeRecordStepItems(settings: NewHireProps, isNep: boolean) {
	const progressItem: ProgressItem[] = [];

	progressItem.push(
		{
			stepName: settings?.personInfoStepName,
			linkUrl: AccountInfoRoutes.PersonalInfoSegment,
			step: BenefitEnrollmentStep.PERSONAL_INFORMATION,
		},
	);
	progressItem.push(
		{
			stepName: settings?.relationshipStepName,
			linkUrl: AccountInfoRoutes.RelationshipsSegment,
			step: BenefitEnrollmentStep.RELATIONSHIP,
		},
	);
	if (!isNep) {
		progressItem.push(
			{
				stepName: settings?.employmentCompensationStepName,
				linkUrl: AccountInfoRoutes.EmploymentSegment,
				step: BenefitEnrollmentStep.EMPLOYMENT,
			},
		);
	}

	return progressItem;
}